import FormField from 'components/form-field/form-field';
import { useFormikContext } from 'formik';
import { AddressModificationModal } from 'modules/company/components/AddressModificationModal';
import { CompanyFormFields } from 'modules/company/types/companyFormFields.type';
import React, { FunctionComponent, useState } from 'react';
import { Button, Divider, Form, Icon } from 'semantic-ui-react';
import { formatAddress } from 'utils/format-address';

type Props = {
  disabled?: boolean;
  label?: string;
};

export const AddressFormField: FunctionComponent<Props> = ({
  disabled,
  label = 'Adresse',
}) => {
  const { values, setValues, setFieldValue, setFieldTouched } =
    useFormikContext<CompanyFormFields>();

  const [addressModalState, setAddressModalState] = useState<{
    isOpen: boolean;
  }>({ isOpen: false });

  return (
    <>
      <Form.Group widths="equal" style={{ marginBottom: 0 }}>
        <FormField
          type="place"
          name="formattedAddress"
          label={label}
          disabled={disabled}
          required
          placeholder="Ex : 15 rue Pierre Dupont, Grenoble"
          onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
            setFieldTouched('formattedAddress', true);
            setValues((prev) => ({
              ...prev,
              formattedAddress: event.target.value,
              address: { streetAddress: '', postalCode: '', city: '' },
            }));
          }}
          onPlaceSelected={(place) => {
            // Get street_number from google autocomplete object
            const streetNumber = place.address_components?.find((item) =>
              item.types.includes('street_number'),
            )?.long_name;

            // Get street name from google autocomplete object
            const streetName = place.address_components?.find((item) =>
              item.types.includes('route'),
            )?.long_name;

            // Get postal code from google autocomplete object
            const postalCode = place.address_components?.find((item) =>
              item.types.includes('postal_code'),
            )?.long_name;

            // Get city from google autocomplete object
            const city = place.address_components?.find((item) =>
              item.types.includes('locality'),
            )?.long_name;

            const street = `${streetNumber ?? ''} ${streetName ?? ''}`.trim();

            setFieldTouched('formattedAddress', true);
            setValues((prev) => ({
              ...prev,
              formattedAddress: place.formatted_address ?? '',
              address: {
                streetAddress: street,
                postalCode: postalCode ?? '',
                city: city ?? '',
              },
            }));
          }}
          options={{
            componentRestrictions: { country: 'fr' },
            fields: ['address_components', 'geometry', 'formatted_address'],
            types: ['address'],
          }}
        />
        {disabled ? null : (
          <Button
            icon
            primary
            style={{
              minWidth: '45px',
              maxHeight: '34px',
              marginTop: '22px',
            }}
            type="button"
            onClick={() => setAddressModalState({ isOpen: true })}
          >
            <Icon name="pencil alternate" />
          </Button>
        )}
      </Form.Group>
      <Divider hidden style={{ margin: '6px 0' }} />
      <AddressModificationModal
        isOpen={addressModalState.isOpen}
        onClose={() => setAddressModalState({ isOpen: false })}
        onValidate={() => {
          setAddressModalState({ isOpen: false });
          const addressFormatted = formatAddress({
            city: values.address.city,
            postalCode: values.address.postalCode,
            street: values.address.streetAddress,
          });
          setFieldValue('formattedAddress', addressFormatted);
        }}
      />
    </>
  );
};
